import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AiFabLogo } from "./AiFabLogo";
import { LazyAIChatPanel } from "./lazyAIChat";

/** Floating AI chat — only inside authenticated app shell (shares PlannerProvider). */
export function AppAiFab() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [chatOpen, setChatOpen] = useState(false);

  const onAiPage = pathname === "/app/ai" || pathname.startsWith("/app/ai/");
  const hideFab = onAiPage;

  useEffect(() => {
    if (onAiPage) setChatOpen(false);
  }, [onAiPage]);

  if (hideFab) return null;

  return (
    <>
      <button
        onClick={() => setChatOpen(!chatOpen)}
        type="button"
        className="ai-fab"
        aria-label={chatOpen ? t("shell.aiClose") : t("shell.aiOpen")}
      >
        {chatOpen ? <span className="ai-fab-close">×</span> : <AiFabLogo />}
      </button>
      {chatOpen && <LazyAIChatPanel onClose={() => setChatOpen(false)} />}
    </>
  );
}
